import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ActiveDashboardsContainer ActContentBlock" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "ActDashboardBlockContent" }
const _hoisted_5 = { class: "ActDashboardTitleSmall" }
const _hoisted_6 = { class: "ActDashboardSubtitleSmall TextGrey" }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "ActDashboardSubtitle ActContentBlock" }, " Active Modules ", -1 /* CACHED */)),
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "ActDashboardText ActContentBlock" }, " These modules are currently available to your organisation. ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(7, (n) => {
            return _createVNode(_component_LoadingWrapper, {
              classes: ['ActWhiteBlock', 'ActiveDashboardBlock'],
              contentIsActive: true,
              isLoading: _ctx.isLoading
            }, null, 8 /* PROPS */, ["isLoading"])
          }), 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.activeDashboards.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activeDashboards, (dashboard) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: dashboard.id,
                    class: "ActWhiteBlock ActiveDashboardBlock",
                    onClick: ($event: any) => (_ctx.navigateToDashboard(dashboard.id))
                  }, [
                    _createElementVNode("img", {
                      class: "ActDashboardBlockIcon",
                      src: _ctx.retrieveIconUrlForDashboard(dashboard),
                      alt: "Dashboard Image"
                    }, null, 8 /* PROPS */, _hoisted_3),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(dashboard.name), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.retrieveAccessLabel(dashboard)), 1 /* TEXT */)
                    ])
                  ], 8 /* PROPS */, _hoisted_2))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, " No active dashboards available. "))
          ], 64 /* STABLE_FRAGMENT */))
    ])
  ]))
}